import React from 'react'
import { Pagination } from 'antd';
import styles from './style/customizePagination.module.less';

class CustomizePagination extends React.Component {
    state = {
        startTime: "",
        endTime: ""
    }



    render() {
        return (
            <div className={styles.paginationDiv}>
                <Pagination {...this.props} />
            </div>
        );
    }
}

export default CustomizePagination